import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { wsPayloadResponse } from '../user/payload';
import { tap, catchError, map } from 'rxjs/operators';
import { PlugpointEnvironment } from '../PlugpointEnvironment';
import { Guid } from 'guid-typescript';
import { GroupData } from './groupMembers';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class DiscountsService {


    // private url = 'https://89.33.44.84:8443/helios/api'; //test
    // private url = 'https://manage.plugpoint.ro:8443/helios/api';
    // private url = 'https://app.plugpoint.ro:8443/helios/api';
    private url = 'https://app.plugpoint.ro:8443/helios/api';

    private token = "4a46889db102438faa83b0b8151898a6";
    public guid = true;
    constructor(
        public http: HttpClient
    ) {
        this.url = PlugpointEnvironment.endpoint;
     }
    private getGatewayAuthHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }


    getVendorPromotions(vendorName: string): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "getPromotions": {
                "vendorName": vendorName
            }
        }
        let body = {
            "token": this.token,
            "action": "promotionData",
            "data": data
        }
        return this.http.post<wsPayloadResponse>(this.url + '/promotionData/getPromotions', body, httpOptions).pipe(
            catchError(this.handleError<wsPayloadResponse>()));
    }

    
    getPromotion(id: number): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "getPromotion": {
                "promotionDataId": id
            }
        }

        let body = {
            "token": this.token,
            "action": "promotionData",
            "data": data
        }
        return this.http.post<wsPayloadResponse>(this.url + '/promotionData/getPromotion', body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    addPromotion(name: string, owner: string, discount: number, startDate: number, endDate: number, stationList: string[], publicCharging: boolean, userName: string, token: string): Observable<any> {

        const url = `${PlugpointEnvironment.url}/gateway/api/promotion/add`;
        const body = {

                promotionName: name,
                promotionOwner: owner,
                discount: discount,
                promotionStart: startDate, // getTime() miliseconds
                promotionEnd: endDate,
                stations: stationList.toString(),
                publicCharging: publicCharging,
                userName: userName,
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

    editPromotion(id: number, name: string, owner: string, discount: number, startDate: number, endDate: number, stationList: string[], userName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/promotion/update`;
        const body = {
                promotionDataId: id,
                promotionName: name,
                promotionOwner: owner,
                discount: discount,
                promotionStart: startDate, // getTime() miliseconds
                promotionEnd: endDate,
                stations: stationList.toString(),
                userName: userName,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

    deletePromotion(id: number, userName: string, owner: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/promotion/delete`;
        const body = {
                promotionDataId: id,
                promotionOwner: owner,
                userName: userName,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

    /*
        * skip
    */
    getVendorGroups(vendorId: string, userName: string = ''): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "getGroups": {
                "vendorName": vendorId,
                "userName": userName
            }
        }
        let body = {
            "token": this.token,
            "action": "groupData",
            "data": data
        }
        console.log(body);
        return this.http.post<wsPayloadResponse>(this.url + '/groupData/getGroups', body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }
    addGroup(userId: string, vendorName: string, groupName: string, discount: number, active: boolean, fleet: boolean, userName: string, token: string, allPrivateStations: boolean = true, stationList: string[] = []): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/add`;
        const body = {
                requester: userId,
                groupName: groupName,
                groupOwner: vendorName,
                discount: discount,
                active: active,
                fleet: fleet,
                publicCharging: false,
                allPrivateStations: allPrivateStations,
                stationList: allPrivateStations ? [] : stationList,
                restrictions:{
                    isACRestricted:false,
                    isDCRestricted:false,
                    kwDayLimit:0,
                    kwMonthLimit:0,
                    sessionsDayLimit:0,
                  },
                userName: userName,
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }
    updateGroup(userId: string, vendorId: string, groupDataId: number, groupName: string, discount: number, active: boolean, userName: string, token:string, allPrivateStations: boolean = true, stationList: string[] = [] ): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/update`;
        const body = {
                requester: userId,
                groupDataId: groupDataId,
                groupName: groupName,
                groupOwner: vendorId,
                discount: discount,
                active: active,
                allPrivateStations: allPrivateStations,
                stationList: allPrivateStations ? [] : stationList,
                userName: userName,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

    updateGrouForPublicCharging(userId: string, group: any,active: boolean, userName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/update/public`;
        const body = {
                requester: userId,
                groupDataId: group.groupDataId,
                groupName: group.groupName,
                groupOwner: group.groupOwner,
                fleet: group.fleet,
                restrictions: {
                    isACRestricted: group.restrictions.isACRestricted,
                    isDCRestricted: group.restrictions.isDCRestricted,
                    kwDayLimit: group.restrictions.kwDayLimit,
                    kwWeekLimit: group.restrictions.kwWeekLimit,
                    sessionsDayLimit: group.restrictions.sessionsDayLimit
                },
                publicCharging: group.publicCharging,
                allPrivateStations: group.allPrivateStations !== false,
                stationList: group.allPrivateStations === false ? (group.stationList || []) : [],
                userName: userName,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }


    deleteGroup(userId: string, groupDataId: number, userName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/delete`;
        const body = {
                requester: userId,
                groupDataId: groupDataId,
                userName: userName,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

 
    getAllPromotions(active: boolean): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "getPromotionsList": {
                "active": active
            }
        }
        let body = {
            "token": this.token,
            "action": "promotionData",
            "data": data
        }
        return this.http.post<wsPayloadResponse>(this.url + '/promotionData/getPromotionsList', body, httpOptions).pipe(
            catchError(this.handleError<wsPayloadResponse>()));
    }

    inviteMemberGroup(userId: string, groupName: string, vendorName: string, userEmail: string, userName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/invite`;
        const body = {
                requester: userId,
                groupName: groupName,
                groupOwner: vendorName,
                userEmail: userEmail,
                userName: userName,
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

    deleteMemberPendingGroup(vendorName: string, userEmail: string, userName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/revoke-invitation`;
        const body = {
                groupOwner: vendorName,
                userEmail: userEmail,
                userName: userName,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }
    getAllPendingByVendor(vendorName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/vendor-pending/${vendorName}`;
        return this.http.get<any>(url, { headers: this.getGatewayAuthHeaders() })
    }

    // getAllPendingByUser(userName: string, token: string): Observable<any> {
    //     const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/user-pending/${userName}`;
    //     return this.http.get<any>(url, { headers: this.getGatewayAuthHeaders(token) })
    /* not used in dashboard, will be done when we get to mobile app
    */
    getAllPendingByUser(userName: string): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "pendingsUser": {
                "userName": userName
            }
        }
        var encodedData = btoa(JSON.stringify(data));
        let body = {
            "token": this.token,
            "action": "groupData",
            "data": encodedData
        }
        return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    addMemberToGroup(userId: string, groupName: string, vendorName: string, userInfo: string, userEmail: string, userName: string, tagId, allPrivateStations: boolean, stations: Array<string>, token:string, allowGroupOverwrite: boolean = true ): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/rfid/add`;
        const body = {
                requester: userId,
                groupName: groupName,
                groupOwner: vendorName,
                userInfo: userInfo,
                userEmail: userEmail,
                userName: userName,
                tagId: tagId,
                allowGroupOverwrite: allowGroupOverwrite,
                allPrivateStations: allPrivateStations,
                stationList: allPrivateStations ? [] : stations
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }
    updateMemberInfo(userId: string, groupId: number, userInfo: string, tagId: string, stations: Array<string>, publicCharging: boolean, isDCRestricted: boolean, isACRestricted: boolean, kwDayLimit: number, kwWeekLimit: number, sessionsDayLimit: number, allStations: boolean, token: string, allowGroupOverwrite: boolean = true): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/member/update`;
        const body = {
                requester: userId,
                groupUserInfoId: groupId,
                userInfo: userInfo,
                tagId: tagId,
                stationList: allStations ? [] : Array.isArray(stations) ? stations.slice() : [],
                publicCharging: publicCharging,
                restrictions:{
                    isACRestricted:isACRestricted,
                    isDCRestricted:isDCRestricted,
                    kwDayLimit:kwDayLimit,
                    kwWeekLimit:kwWeekLimit,
                    sessionsDayLimit:sessionsDayLimit,
                  },
                allPrivateStations: allStations,
                allowGroupOverwrite: allowGroupOverwrite,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

    deleteMemberFromGroup(userId: string, groupName: string, vendorName: string, userEmail: string, tagId: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/member/delete`;
        const body = {
                requester: userId,
                groupOwner: vendorName,
                userEmail: userEmail,
                tagId: tagId,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() })
    }

    getMembersByGroup(groupName: string, vendorName: string, token: string): Observable<any> {

        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/group/member/get`;
        const body = {
                groupName: groupName,
                groupOwner: vendorName,
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() })
        // if(this.guid == true){
        //     this.token = Guid.create().toString();
        //     }
        // let data = {
        //     "getMembers": {
        //         "groupName": groupName,
        //         "groupOwner": vendorName,
        //     }
        // }
        // var encodedData = btoa(JSON.stringify(data));
        // let body = {
        //     "token": this.token,
        //     "action": "groupData",
        //     "data": encodedData
        // }
        // return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
        //     // tap(_ => console.log("hehe")),
        //     catchError(this.handleError<wsPayloadResponse>()));
    }

    /*
        * skip for now
    */
    getUserGroups(userName: string): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "showGroups": {
                "userName": userName,
            }
        }

        let body = {
            "token": this.token,
            "action": "groupData",
            "data": data
        }
        return this.http.post<wsPayloadResponse>(this.url + '/groupData/showGroups', body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    /*
        * not used
    */
    getGroupInfo(groupId: number): Observable<any> {
        var finalUrl = PlugpointEnvironment.haproxyEndpoint + "fleet/get-group-info/" +groupId;
        return this.http.get<GroupData>(finalUrl, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }





    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            // console.error(error); // log to console instead


            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
